<template>
  <div class="share-wrap" v-wechat-title="$route.meta.title">
    <header class="open-truckpath" ref="header">
      <!-- <img src="@/assets/images/logo.svg" alt="logo" class="logo" /> -->
      <img
        src="@/assets/images/logo.png"
        class="logo"
        srcset="@/assets/images/logo@2x.png 2x, @/assets/images/logo@3x.png 3x"
      />
      <button
        v-if="clickName === 'touchstart'"
        class="open-btn"
        href="zjmobile://platformapi/startapp"
        @touchstart="handleOpenApp"
      >Open</button>
      <button
        v-else
        class="open-btn"
        href="zjmobile://platformapi/startapp"
        @click="handleOpenApp"
      >Open</button>
    </header>
    <section class="post-container" :style="{overflow:isOpenMore?'hidden':'auto'}">
      <div class="container-wrap" ref="containerWrap">
        <div class="post-detail">
          <user-info :hasMore="false" :authorInfo="postData.authorInfo" :timeAgo="postData.timeAgo"></user-info>
          <div class="post-content">
            <p
              class="content-title"
            >{{postData.title ||'Chinese Web giant Tencent rolls out toughest gaming restrictions amid crackdown on industry'}}</p>
            <!-- video贴相关 -->
            <p
              v-if="postData.threadType&&postData.threadType === 'VIDEO'"
              class="content-video"
            >
              <!-- <p class="content-video" @mouseenter="enterVideo"> -->
              <video id="myVideo" class="video-js" v-if="postData.videos[0].url">
                <source :src="postData.videos[0].url" type="video/mp4" />
              </video>
              <img v-else src alt="no video" />
              <img
                v-if="clickName==='touchstart'"
                :class="isPlay? 'play-video appearIcon-no' : 'play-video appearIcon-yes'"
                src="@/assets/images/icon-play@2x.png"
                alt="play"
                @touchstart="handlePlay"
              />
              <img
                v-else
                :class="isPlay? 'play-video appearIcon-no' : 'play-video appearIcon-yes'"
                src="@/assets/images/icon-play@2x.png"
                alt="play"
                @click="handlePlay"
              />
            </p>
            <!-- 水贴相关 -->
            <p v-if="postData.threadType&&postData.threadType === 'GENERAL'" class="content-water">
              <span v-if="postData.text" class="general-text">{{postData.text}}</span>
              <span v-if="postData.pics&&postData.pics.length" class="general-pics">
                <img
                  :src="postData.pics[0].url?postData.pics[0].url:require('@/assets/images/test.png')"
                  alt
                />
              </span>
            </p>
            <!-- link贴相关 -->
            <p v-else-if="postData.threadType&&postData.threadType === 'LINK'" class="content-link">
              <span class="link-pic">
                <img class="pic-url" src="@/assets/images/test.png" alt />
                <span class="link-url">
                  <a
                    v-if="postData.webLink"
                    :href="postData.webLink.url?postData.webLink.url:'#'"
                  >{{ postData.webLink.title? postData.webLink.title: 'truckpath.com'}}</a>
                  <img src="@/assets/images/link.svg" alt="link" class="link-icon" />
                </span>
                <span class="link-text">{{postData.text}}</span>
              </span>
            </p>
            <p class="content-location">
              <span class="location-name">
                <img
                  src="@/assets/images/2.png"
                  srcset="@/assets/images/2@2x.png 2x, @/assets/images/2@3x.png 3x"
                />
              </span>
              {{postData.forumName}}
            </p>
          </div>
        </div>
        <div class="post-comments">
          <h6 class="comment-title">Comments</h6>
          <div v-if="commentsData.resultList&&commentsData.resultList.length">
            <div class="comments-container" v-for="(item,i) in commentsData.resultList" :key="i">
              <user-info :authorInfo="item.authorInfo"></user-info>
              <div class="comment-content">
                <p class="content-replay" v-if="item.replyToText">
                  <span class="replay-name">{{item.replyToAuthorInfo.nickName}}</span>
                  <span class="replay-text">{{item.replyToText}}</span>
                </p>
                <p
                  class="content-main"
                >{{item.text||'defaultdefaultdefaultdefaultdefaultdefaultdefaultdefault'}}</p>
              </div>
              <div class="comment-features">
                <p
                  v-if="clickName==='touchstart'"
                  class="coment-replay"
                  @touchstart="handleOpenApp"
                >
                  <!-- <img src="@/assets/" alt /> -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon-replay" viewBox="0 0 30 30">
                    <path
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#666B8B"
                      stroke-width="2"
                      d="M6 20.101v.019l-.031.013.031-.032zm0-.273h.282A6.978 6.978 0 0 1 11 18h6v2.827a1 1 0 0 0 1.74.672l5.297-5.826a1 1 0 0 0 0-1.346L18.74 8.501a1 1 0 0 0-1.74.672V12h-6a5 5 0 0 0-5 5v2.828z"
                    />
                  </svg>
                  <span>Reply</span>
                </p>
                <p v-else class="coment-replay" @click="handleOpenApp">
                  <!-- <img src="@/assets/" alt /> -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon-replay" viewBox="0 0 30 30">
                    <path
                      fill="none"
                      fill-rule="evenodd"
                      stroke="#666B8B"
                      stroke-width="2"
                      d="M6 20.101v.019l-.031.013.031-.032zm0-.273h.282A6.978 6.978 0 0 1 11 18h6v2.827a1 1 0 0 0 1.74.672l5.297-5.826a1 1 0 0 0 0-1.346L18.74 8.501a1 1 0 0 0-1.74.672V12h-6a5 5 0 0 0-5 5v2.828z"
                    />
                  </svg>
                  <span>Reply</span>
                </p>
                <p class="comments-like">
                  <span class="like">
                    <img v-if="clickName==='touchstart'"
                      src="@/assets/images/commu-icon-up-nor-gray.png"
                      srcset="@/assets/images/commu-icon-up-nor-gray@2x.png 2x, @/assets/images/commu-icon-up-nor-gray@3x.png 3x"
                      class="Commu_icon_up_nor_gray"
                      @touchstart="handleOpenApp"
                    />
                    <img v-else
                      src="@/assets/images/commu-icon-up-nor-gray.png"
                      srcset="@/assets/images/commu-icon-up-nor-gray@2x.png 2x, @/assets/images/commu-icon-up-nor-gray@3x.png 3x"
                      class="Commu_icon_up_nor_gray"
                      @click="handleOpenApp"
                    />
                  </span>
                  <span class="like-num">{{item.likeNum||1}}</span>
                  <span class="dislike">
                    <img
                      v-if="clickName==='touchstart'"
                      src="@/assets/images/commu-icon-down-nor-gray.png"
                      srcset="@/assets/images/commu-icon-down-nor-gray@2x.png 2x, @/assets/images/commu-icon-down-nor-gray@3x.png 3x"
                      class="Commu_icon_down_nor_gray"
                      @touchstart="handleOpenApp"
                    />
                    <img
                      v-else
                      src="@/assets/images/commu-icon-down-nor-gray.png"
                      srcset="@/assets/images/commu-icon-down-nor-gray@2x.png 2x, @/assets/images/commu-icon-down-nor-gray@3x.png 3x"
                      class="Commu_icon_down_nor_gray"
                      @click="handleOpenApp"
                    />
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="post-end" v-if="commentsData.resultList&&commentsData.resultList.length">
          <p class="end-text" v-if="page===commentsData.totalPage-1">
            <i></i>
            <span>the end</span>
            <i></i>
          </p>
          <p v-if="clickName==='touchstart'" class="end-page" @touchstart="isshowPageDialog=true">
            <span class="cur-page">{{page+1}}</span> /
            <span class="total-page">{{commentsData.totalPage}}</span> page
          </p>
          <p v-else class="end-page" @click="isshowPageDialog=true">
            <span class="cur-page">{{page+1}}</span> /
            <span class="total-page">{{commentsData.totalPage}}</span> page
          </p>
        </div>
        <div class="comments-nodata" v-else>
          <img
            src="@/assets/images/no-result.png"
            srcset="@/assets/images/no-result@2x.png 2x, @/assets/images/no-result@3x.png 3x"
            class="no-result"
          />
          <p>No comment yet</p>
        </div>
        <div class="post-submit">
          <div class="comment-features">
            <p
              v-if="clickName==='touchstart'"
              class="comment-add"
              @touchstart="handleOpenApp"
            >Add a comment</p>
            <p v-else class="comment-add" @click="handleOpenApp">Add a comment</p>
            <p class="comments-like">
              <span class="like">
                <img
                  v-if="clickName==='touchstart'"
                  src="@/assets/images/commu-icon-up-nor-gray.png"
                  srcset="@/assets/images/commu-icon-up-nor-gray@2x.png 2x, @/assets/images/commu-icon-up-nor-gray@3x.png 3x"
                  class="Commu_icon_up_nor_gray"
                  @touchstart="handleOpenApp"
                />
                <img
                  v-else
                  src="@/assets/images/commu-icon-up-nor-gray.png"
                  srcset="@/assets/images/commu-icon-up-nor-gray@2x.png 2x, @/assets/images/commu-icon-up-nor-gray@3x.png 3x"
                  class="Commu_icon_up_nor_gray"
                  @click="handleOpenApp"
                />
              </span>
              <span class="like-num">{{postData.likeNum || 1}}</span>
              <span class="dislike">
                <img
                  v-if="clickName==='touchstart'"
                  src="@/assets/images/commu-icon-down-nor-gray.png"
                  srcset="@/assets/images/commu-icon-down-nor-gray@2x.png 2x, @/assets/images/commu-icon-down-nor-gray@3x.png 3x"
                  class="Commu_icon_down_nor_gray"
                  @touchstart="handleOpenApp"
                />
                <img
                  v-else
                  src="@/assets/images/commu-icon-down-nor-gray.png"
                  srcset="@/assets/images/commu-icon-down-nor-gray@2x.png 2x, @/assets/images/commu-icon-down-nor-gray@3x.png 3x"
                  class="Commu_icon_down_nor_gray"
                  @click="handleOpenApp"
                />
              </span>
              <span class="like-fav">
                <img
                  v-if="clickName==='touchstart'"
                  src="@/assets/images/invalid-fav.png"
                  srcset="@/assets/images/invalid-fav@2x.png 2x, @/assets/images/invalid-fav@3x.png 3x"
                  class="favorite-icon"
                  @touchstart="handleOpenApp"
                />
                <img
                  v-else
                  src="@/assets/images/invalid-fav.png"
                  srcset="@/assets/images/invalid-fav@2x.png 2x, @/assets/images/invalid-fav@3x.png 3x"
                  class="favorite-icon"
                  @click="handleOpenApp"
                />
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <choose-more :isMask="isMask" @handleOpenApp="handleOpenApp" :clickName="clickName"></choose-more>
    <footer class="footer" v-if="isOpenMore">
      <p class="footer-mask">
        <span v-if="clickName==='touchstart'" class="open-app" @touchstart="isOpenMore = false">
          <img
            src="@/assets/images/open.png"
            srcset="@/assets/images/open@2x.png 2x, @/assets/images/open@3x.png 3x"
            class="open"
          />
        </span>
        <span v-else class="open-app" @click="isOpenMore = false">
          <img
            src="@/assets/images/open.png"
            srcset="@/assets/images/open@2x.png 2x, @/assets/images/open@3x.png 3x"
            class="open"
          />
        </span>
        <button
          v-if="clickName==='touchstart'"
          class="open-btn"
          @touchstart="handleOpenApp"
        >Optimize Your Experience</button>
        <button v-else class="open-btn" @click="handleOpenApp">Optimize Your Experience</button>
      </p>
    </footer>
    <loading :isFinish="isLoadingFinish"></loading>
    <!-- 页码弹框 -->
    <page-dialog
      :showPageDialog="isshowPageDialog"
      :totalPage="commentsData.totalPage"
      @handleChangePage="handleChangePage"
      :clickName="clickName"
    ></page-dialog>
    <!-- 提示浏览器打开弹窗 -->
    <browser-tips :isOpenBrowser="isOpenBrowser" @cancelTips="handleCancelTips" :version="version"></browser-tips>
    <!-- 打开app弹窗 -->
    <!-- <div class="open-app-dialog">
      <div class="dialog-container">
        <p class="dialog-title">open the truckerpath</p>
      </div>
    </div>-->
    <windows-tips :isWindowTips="isWindowTips" @closeWindowsTip="closeWindowsTip"></windows-tips>
  </div>
</template>
<script>
import { getThread, getComments } from '@/api/sharing'
import userInfo from './components/user-info'
import chooseMore from './components/choose-more'
import loading from '@/components/loading'
import pageDialog from './components/page-dialog'
import browserTips from './components/browser-tips'
import windowsTips from './components/windows-tips'
import { timestampFormat } from '@/utils/formatTime'
import { clearTimeout, setTimeout } from 'timers'
import { getMobelType, deepLink } from '@/utils/getMobelType.js'
import gaSevice from '@/utils/initGA.js'
import "@/utils/flexible.js";
export default {
  components: {
    userInfo,
    chooseMore,
    loading,
    pageDialog,
    browserTips,
    windowsTips
  },
  data() {
    return {
      isPlay: false, //视频是否正在播放
      isOpenMore: true, //是否打开全文
      isMask: false,
      isshowPageDialog: false, //是否显示页面弹框
      isLoadingFinish: false, //数据是否加载完成
      isOpenBrowser: false,
      isCallSuceess: false, //是否成功调起app
      isWindowTips: false, //是否打开windowstips
      myPlayer: null, //video视频实例
      // clickCount: 0, //点击次数
      page: 0, //当前页码
      postData: {}, // 当前帖子详情数据
      commentsData: {}, // 评论回复列表
      version: {}, //当前机型
      clickName: 'click',
      source: '',
      deepLinkUrl: deepLink('schema')
    }
  },
  beforeCreate() {
    document.title = this.$route.params.title
    gaSevice.addScript()
  },
  async mounted() {
    import('video.js/dist/video-js.css');
    gaSevice.emit('Open', 'ga', { event_label: `tid:${this.$route.query.tid}` })
    this.version = getMobelType()
    this.OSnow()
    //获取帖子id
    // 判断页面是否遗鸥滚动条
    try {
      let res = await getThread(this.$route.query.tid)
      if (res.status === 200) {
        this.postData = res.data.data
        this.postData.timeAgo = timestampFormat(res.data.data.showTime)
        switch (res.data.data.threadType) {
        case 'GENERAL':
          this.deepLinkUrl = this.deepLinkUrl + '/post/' + this.$route.query.tid
          break
        case 'VIDEO':
          this.deepLinkUrl = this.deepLinkUrl + '/video/' + this.$route.query.tid
          break
        case 'LINK':
          this.deepLinkUrl = this.deepLinkUrl + '/link/' + this.$route.query.tid
          break
        }
      }
      await this.getCommentList(this.page)
      let sectionH = this.$refs.containerWrap.offsetHeight + this.$refs.header.offsetHeight
      let doclientH = window.innerHeight || document.documentElement.clientHeight
      if (sectionH < doclientH) {
        this.isOpenMore = false
      } else {
        this.isOpenMore = true
      }
    } catch (e) {
      new Error(e)
    }
    this.$bus.$on('toggleMask', () => {
      this.isMask = !this.isMask
    })
    if ('ontouchstart' in document.documentElement === true) {
      this.clickName = 'touchstart'
    } else {
      this.clickName = 'click'
    }
    if (this.postData.threadType && this.postData.threadType === 'VIDEO') {
        import('video.js').then((Video) => {
            this.initVideo(Video.default)
      });
    }
  },
  methods: {
    initVideo($video) {
      /* eslint-disable no-undef */
      //初始化视频方法
      this.myPlayer = $video(myVideo, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: false,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: 'auto',
        width: '800px',
        height: '400px'
      })
    },
    handlePlay() {
      // this.myPlayer.trigger()
      this.$nextTick(() => {
        if (!this.isPlay) {
          this.myPlayer.play()
          this.isPlay = true
        } else {
          this.myPlayer.pause()
          this.isPlay = false
        }
      })
    },
    closeWindowsTip() {
      this.isWindowTips = false
    },
    //判断操作系统
    OSnow() {
      let agent = navigator.userAgent.toLowerCase()
      let isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
        this.isWindowTips = true
      }
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
        alert('Please open in your mobile')
        this.isWindowTips = true
      }
      if (isMac) {
        this.isWindowTips = false
      }
    },

    //获取评论列表
    async getCommentList(page) {
      let commentsRes = await getComments({ tid: this.$route.query.tid, page })
      if (commentsRes.status === 200) {
        this.commentsData = commentsRes.data.data
        this.isLoadingFinish = true
        this.$nextTick(() => {
          let sectionH = this.$refs.containerWrap.offsetHeight + this.$refs.header.offsetHeight
          let doclientH = window.innerHeight || document.documentElement.clientHeight
          if (sectionH < doclientH) {
            this.isOpenMore = true
          }
        })
      }
    },
    async handleChangePage(page) {
      this.page = page
      await this.getCommentList(page)
      this.isshowPageDialog = false
    },

    //打开app
    handleOpenApp(e) {
      e = e || window.event
      var timeout = 5300,
        timer = null
      if (this.version.weixin) {
        this.isOpenBrowser = true
      } else {

        var startTime = Date.now()
        if (this.version.android) {
          // console.log(this.deepLinkUrl,'....this.deepLinkUrl')
          gaSevice.emit('Open Android App', 'ga', { event_label: `tid:${this.$route.query.tid}` })
          // window.location.href = this.deepLinkUrl + Date.now()
          if(e.preventDefault) {
            e.preventDefault();
          }else{
            e.returnValue = false;
          }
          window.open(this.deepLinkUrl + '?utm_source=share&time=' + Date.now(), '_self') //唤起协议，由iOS小哥哥提供
          // window.location.href = this.deepLinkUrl + '?time=' + Date.now()
          timer = setTimeout(() => {
            let endTime = Date.now()
            if (!startTime || endTime - startTime < timeout + 100) {
              window.open('https://play.google.com/store/apps/details?id=com.sixdays.truckerpath')
              gaSevice.emit('shareTo', 'ga', { shareTo: 'googlePlay' })
            }
          }, timeout)
        }
        if (this.version.ios || this.version.iPhone || this.version.iPad) {
          gaSevice.emit('Open IOS App', 'ga', { event_label: `tid:${this.$route.query.tid}` })
          if (this.version.qq) {
            this.isOpenBrowser = true
          } else {
            window.open(this.deepLinkUrl + '?utm_source=share&time=' + Date.now(), '_self') //唤起协议，由iOS小哥哥提供

            timer = setTimeout(() => {
              let endTime = Date.now()
              if (!startTime || endTime - startTime < timeout + 100) {
                window.open('https://apps.apple.com/cn/app/truckerpath/id782746890')
                gaSevice.emit('shareTo', 'ga', { shareTo: 'appStore' })
              }
            }, timeout)
          }
        }
      }
      document.addEventListener('visibilitychange webkitvisibilitychange', function() {
        var tag = document.hidden || document.webkitHidden
        if (tag) {
          clearTimeout(timer)
        }
      })
      window.addEventListener('pagehide', function() {
        clearTimeout(timer)
      })
    },
    preventDefault(e) {
      e = e || window.event;
      if(e.preventDefault) {
        e.preventDefault();
      }else{
        e.returnValue = false;
      }
    },
    //取消在浏览器打开的蒙版
    handleCancelTips() {
      this.isOpenBrowser = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../scss/rem.scss';
.display {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.myVideo-dimensions {
  width: 100%;
}
::v-deep .video-js {
  width: 100%;
  height: 100%;
}
.share-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: rem(14px);
  max-width: rem(375px);
  margin: 0 auto;
}
.open-truckpath {
  z-index: 999999;
  position: relative;
  @extend .display;
  justify-content: space-between;
  width: 100%;
  height: rem(60px);
  padding: 0 rem(15px);
  background: url('../../assets/images/invalid-name@2x.png') repeat left center;
  // box-shadow: 0 3px 6px 0 rgba(62, 67, 101, 0.13);
  background-size: contain;

  .logo {
    width: rem(212px);
    height: rem(30px);
    object-fit: contain;
    flex-shrink: 0;
  }
  .open-btn {
    width: rem(80px);
    height: rem(32px);
    line-height: rem(32px);
    border-radius: rem(18px);
    background-color: #008adb;
    font-weight: 500;
    font-size: rem(15px);
    color: #ffffff;
    text-align: center;
    border: 0;
    outline: none;
    cursor: pointer;
  }
}
.comments-container {
  padding: 0 rem(15px);
  margin-bottom: rem(15px);
}
.container-wrap {
  height: auto;
}
.comments-nodata {
  @extend .display;
  flex-direction: column;
  width: 100%;
  height: rem(150px);
  background: #fff;
  font-size: rem(14px);
  color: #666b8b;
  font-size: rem(13px);
  line-height: 1.38;
  > .no-result {
    width: rem(102px);
    margin-bottom: rem(12px);
  }
}
.post-container {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  background: #f2f4f8;
  .post-detail {
    background: #fff;
    margin-bottom: rem(10px);
    padding: 0 rem(15px);
  }
}

.content-title {
  width: 100%;
  height: auto;
  font-size: rem(17px);
  // padding: rem(13px) 0 rem(15px) 0;
  font-weight: bold;
  line-height: 1.29;
  color: #141a42;
}
.content-video {
  width: 100%;
  height: rem(200px);
  text-align: center;
  position: relative;
}
.content-water {
  font-size: rem(13px);
  line-height: 1.85;
  height: auto;
  color: #141a42;

  .general-text {
    word-wrap: break-word;
  }
}
.general-pics {
  @extend .display;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  min-height: rem(200px);
  > img {
    width: 100%;
  }
}
//link帖子
.content-link {
  @extend .display;
  flex-direction: column;
  width: 100%;
  height: auto;
  > .link-pic {
    @extend .display;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    height: rem(250px);
    background: rgb(241, 244, 249);
    align-items: flex-start;
    .pic-url {
      width: 100%;
      height: 75%;
    }
    .link-url {
      @extend .display;
      justify-content: flex-start;
      padding: 0 rem(10px);
      margin: rem(5px) 0;
      > a {
        color: #141a42;
        font-weight: 500;
      }
    }
    .link-text {
      display: -webkit-box;
      width: 100%;
      font-size: rem(13px);
      color: rgb(111, 113, 148);
      padding: 0 rem(10px);
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.content-location {
  @extend .display;
  justify-content: flex-start;
  width: 100%;
  padding: rem(15px) 0 rem(22px);
  font-size: rem(13px);
  font-weight: 500;
  color: #666b8b;
  > .location-name {
    width: rem(20px);
    height: rem(22px);
    margin-right: rem(4px);
    padding: rem(1px);
    > img {
      width: 100%;
    }
  }
}

.Bitmap {
  width: rem(345px);
  height: rem(200px);
}
.play-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 1s linear;
}
.appearIcon-yes {
  opacity: 1;
}
.appearIcon-no {
  opacity: 0;
}
.post-comments {
  width: 100%;
  height: auto;
  // margin-bottom: rem(10px);
  background: #fff;
  > .comment-title {
    padding: rem(15px);
    font-family: SFUIText;
    font-size: rem(17px);
    font-weight: bold;
    line-height: 1.18;
    color: #141a42;
  }
}
//评论内容
.comment-content {
  width: 100%;
  .content-replay {
    @extend .display;
    justify-content: flex-start;
    width: 100%;
    min-height: rem(40px);
    padding: 0 rem(15px);
    margin: rem(15px) 0;
    background: #f6f7fa;
    .replay-name {
      font-size: rem(12px);
      color: #777;
    }
    .replay-text {
      height: auto;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: rem(3px);
      font-size: rem(13px);
      color: #333;
    }
  }
  .content-main {
    margin-top: rem(15px);
    word-wrap: break-word;
    font-family: SFUIText;
    font-size: rem(15px);
    font-weight: bold;
    line-height: 1.47;
    color: #141a42;
  }
}
//评论功能
.comment-features {
  @extend .display;
  justify-content: space-between;
  width: 100%;
  padding: rem(20px) 0;
  border-bottom: rem(1px) solid #e7ebf3;
  .coment-replay {
    @extend .display;
    justify-content: flex-start;
    object-fit: contain;
    font-size: rem(15px);
    font-weight: 500;
    color: #666b8b;
    .icon-replay {
      width: rem(30px);
      height: rem(30px);
      cursor: pointer;
    }
  }
  .comments-like {
    @extend .display;
    justify-content: flex-start;
    height: rem(30px);
    .like-num {
      height: rem(30px);
      line-height: rem(27px);
      object-fit: contain;
      font-family: SFUIText;
      font-size: rem(13px);
      font-weight: 500;
      padding: 0 rem(2px);
      text-align: center;
      color: #666b8b;
    }
  }
}

//icons
.Commu_icon_up_nor_gray,
.Commu_icon_down_nor_gray {
  width: rem(33px);
  height: rem(33px);
  object-fit: contain;
  cursor: pointer;
}
.favorite-icon {
  width: rem(25px);
  height: rem(25px);
  object-fit: contain;
  margin-left: rem(7px);
  cursor: pointer;
}
.link-icon {
  width: rem(15px);
  height: rem(15px);
  color: rgb(103, 105, 142);
}
//回复内容
.comment-content {
  width: 100%;
}

//post-end
.post-end {
  @extend .display;
  justify-content: flex-end;
  padding-right: rem(16px);
  position: relative;
  width: 100%;
  height: rem(60px);
  margin-top: rem(-10px);
  .end-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @extend .display;
    justify-content: flex-start;
    > i {
      width: rem(30px);
      height: rem(1px);
      opacity: 0.3;
      background-color: #a5a7b7;
    }
    > span {
      font-size: rem(13px);
      font-weight: 500;
      line-height: 1.54;
      color: #a5a7b7;
      margin: 0 rem(8px);
    }
  }
}
//展示页
.end-page {
  width: rem(70px);
  height: rem(24px);
  line-height: rem(24px);
  border-radius: rem(4px);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.9);
  font-family: Gotham;
  font-size: rem(11px);
  text-align: center;
  color: rgba(51, 51, 51, 0.6);
  cursor: pointer;
  > .cur-page {
    color: #444;
  }
}
//提交评论
.post-submit {
  @extend .display;
  flex-direction: column;
  padding: 0 rem(15px);
  width: 100%;
  height: rem(60px);
  box-shadow: 0 0 rem(8px) 0 rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  > .comment-features {
    padding: 0;
    border: 0;
  }
}
//添加评论
.comment-add {
  width: rem(200px);
  height: rem(40px);
  opacity: 0.5;
  border-radius: rem(20px);
  text-align: center;
  line-height: rem(40px);
  background-color: #f2f4f8;
  font-family: Gotham;
  font-size: rem(14px);
  color: #666b8b;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: rem(58px);
  z-index: 9999999;
  @extend .display;
  flex-direction: column;
  justify-content: flex-end;
  background: transparent;
  .footer-mask {
    @extend .display;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    height: rem(200px);
    margin-top: rem(-100px);
    background-image: linear-gradient(to bottom, rgba(250, 250, 250, 0), #efefef);
    padding-bottom: rem(10px);
    .open-app {
      width: rem(24px);
      height: rem(24px);
      margin-bottom: rem(26px);
      animation: openImg 0.7s infinite ease-out;
      > img {
        width: 100%;
      }
    }
    .open-btn {
      width: rem(345px);
      height: rem(44px);
      border-radius: rem(22px);
      background-color: #008adb;
      font-size: rem(15px);
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
@keyframes openImg {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(rem(8px));
  }
  100% {
    transform: translateY(0);
  }
}
.open-app-dialog {
  position: absolute;
  z-index: 99999999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  .dialog-container {
    width: 70%;
    height: rem(150px);
    background: #fff;
    border-radius: rem(4px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
